<template>
  <div class="container">
    <h4 class="my-3">Edição de Contas</h4>
    <b-card no-body class="mb-3">
      <b-tabs pills card vertical>
        <div v-if="getCustomers.length == 0" class="text-center">
          <b-spinner label="Busy" class="mt-5"></b-spinner>
        </div>
        <div v-else>
          <b-tab
            v-for="customer in getCustomers"
            :key="customer.id"
            v-bind:title="customer.fullName + ' - ' + customer.extraInfo"
            lazy
          >
            <b-tabs content-class="mt-3" fill>
              <b-tab title="Dados" active>
                <Account :customer="customer"></Account>
              </b-tab>
              <b-tab title="Permissões Extras">
                <ExtraPermissions :customer="customer"></ExtraPermissions>
              </b-tab>
            </b-tabs>
          </b-tab>
        </div>
        </b-tabs>
      </b-card>
  </div>
</template>

<script>
import Account from "./Account";
import ExtraPermissions from "./ExtraPermissions"
export default {
  name: "EditAccount",
  components: {
    Account,
    ExtraPermissions,
  },
  computed: {
    getCustomers() {
      return this.$store.getters.getCustomers;
    }
  },
  created() {
    this.$store.dispatch("retrieveCustomers");
    this.$store.dispatch("retrieveProfiles");
  }
};
</script>

<style>
</style>